import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ArticleService } from '@digiwall/goliath-products/proxy';
import { TableRowComponent } from '@digiwall/ui-kit';
import { TableComponent } from '@digiwall/ui-kit';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LocalizationModule } from '@abp/ng.core';

export interface Packaging {
  articleId: string;
  description: string;
  quantity: number;
}

@Component({
  selector: 'document-delivery-note-packaging-grid',
  templateUrl: './delivery-note-packaging-grid.component.html',
  styleUrl: './delivery-note-packaging-grid.component.scss',
  imports: [
    CommonModule,
    TableComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    TableRowComponent,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    ReactiveFormsModule,
    FormsModule,
    LocalizationModule,
  ],
})
export class DeliveryNotePackagingGridComponent {
  @Input() packagingList: Packaging[] = [];

  protected packagings;
  protected rows: TableRowComponent[];
  protected selectedRows: TableRowComponent[] = [];

  constructor(protected articleService: ArticleService) {
    articleService.getPackagings(true).subscribe(packagings => {
      this.packagings = packagings;
    });
  }

  protected onSelectionChange($event: TableRowComponent[]) {
    this.rows = $event;
    this.selectedRows = $event.filter(x => x.selected);
  }

  addPackage() {
    this.packagingList.push({ articleId: null, description: '', quantity: 1 });
  }

  removeSelectedPackages() {
    this.selectedRows.forEach(row => {
      let index = this.rows.findIndex(x => x == row);
      if (index != -1) {
        this.rows.splice(index, 1);
      }
      let indexData = this.packagingList.findIndex(x => x == row.data);
      if (indexData != -1) {
        this.packagingList.splice(indexData, 1);
      }
    });
  }

  protected articleChange(article, packaging: Packaging) {
    packaging.description = article != null ? article.name.current : null;
  }
}
